import { render, staticRenderFns } from "./CategoryActionDelete.vue?vue&type=template&id=05060723&"
import script from "./CategoryActionDelete.vue?vue&type=script&lang=ts&"
export * from "./CategoryActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports